module.exports = {
	"hello": "Hallo, Welt!",
	"Größe": "Size",
	"Themenwelten": "Themes",
	"Bitte wählen Sie eine Lieferadresse aus:": "Please choose your delivery address",
	"min_order_value": "minimum order value",
	"min_order_value_ok": "minimum order value reached",
	"availability": {
		"soon": "available soon",
		"available": "available"
	},
	"delivery": "Delivery",
	"product": {
		"availability": "Availability",
		"deliverable": "Availability",
		"articlenr": "Art-No.",
		"popularity": "popularity",
		"price": "price",
		"single_price": "item price",
		"label": "label",
		"sum": "sum",
		"amount": "items",
		"piece": "items"
	},
	"address": {
		"address": "Address",
		"salutation": "salutation",
		"company": "company",
		"surname": "surname",
		"street": "street",
		"invoice": "invoice address",
		"addition": "addition",
		"pcode": "Postcode",
		"country": "country",
		"city": "city",
		"first_name": "first name",
		"delivery_address": "delivery address"
	},
	"products": {
		"search": "Search (Art.No., EAN, Name)"
	},
	"orderlist": {
		"add": "save",
		"on_orderlist": "on list",
		"added": "saved",
		"all_lists": "all lists"
	},
	"csv": {
		"uploadFile": "upload file"
	},
	"category": {
		"from_this_category": "from this category",
		"last_viewed": "last viewed"
	},
	"shop": {
		"login": "Login",
		"register": "Register",
		"user": "User",
		"password": "Password",
		"lost_password": "Lost Password?",
		"VE": "VE",
		"create": "create",
		"finalize_order": "order",
		"please_login_for_product_details": "Please register or log in to see product details",
		"continue_shopping": "continue shopping",
		"check_and_confirm": "check and confirm",
		"navigate_to_checkout": "checkout",
		"sort": "sort",
		"deliverable": "available",
		"article": "article",
		"articles_per_site": "articles per page",
		"to_top": "to top",
		"add_all_products": "add all products",
		"add": "add",
		"select": "select",
		"close": "close",
		"open": "open",
		"selected": "selected",
		"delete": "remove",
		"list": "list",
		"back": "back",
		"comment": "comment",
		"add_new_address": "add new address",
		"AGB_DELIVERY_INFO": "AGB and delivery information",
		"CONFIRM_AGB_DELIVERY_INFO": "AGB and delivery information confirmed",
		"continue": "continue"
	},
	"cart": {
		"your_comment": "your comment",
		"cart": "cart",
		"positions": "positions",
		"piece": "piece",
		"subtotal": "subtotal",
		"address": "address",
		"check_and_submit": "check and submit"
	},
	"nav": {
		"account": "account",
		"logout": "logout",
		"quickorder": "quickorder",
		"service": "service",
		"privacy": "privacy",
		"menu": "menu",
		"orderlist": "list"
	},
	"message": {
		"min_order_value": "You haven't reached the minimal order value yet (%{value} EUR)",
		"empty_cart": "You don't have any products in your cart"
	},
	"misc": {
		"price_a_piece": "price per item"
	},
	"footer": {
		"delivery": "delivery",
		"imprint": "imprint",
		"contact": "contact",
		"request_catalogue": "request catalogue",
		"new_client": "registration",
		"change_address": "change address",
		"AGB": "AGB"
	},
	"reset": {
		"reset": "Reset Password",
		"your_mail": "Your E-Mail",
		"back": "Back",
		"choose_password": "Choose a password",
		"your_new_password": "Your new password",
		"repeat_password": "repeat password",
		"set_password": "set password",
		"too_short": "Your password is too short",
		"too_short_explained": "please choose a longer password",
		"passwords_not_equal": "passwords are not equal",
		"passwords_not_equal_explained": "You have not entered the same password twice",
		"success": "Your password has been set",
		"success_explained": "We have send reset instructions to your E-Mail %email",
		"success_explained_long": "Please follow the instructions in your E-Mail. If you can't receive E-Mails the service hotline will be able to provide further assistance",
		"mail_not_found": "E-Mail is not registered",
		"mail_not_found_explained": "We could not find an account with your E-Mail."
	},
	"strings": {
		"new_account_hint": "Do you need an account?",
		"new_account_action": "Register",
		"new_account_enabled": "Enable Account (You have previously ordered here)"
	},
	"error": {
		"login_error": "Invalid Credentials"
	},
	"brand_not_avail": "Unfortunately this brand is not available for your country."
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 834
// module chunks = 0